/* ============================================================
   Pingion Games — scroll-reveal (homepage)
   Zet stagger-index op grid-kinderen en togglet .is-in zodra een
   element in beeld scrolt (IntersectionObserver). Werkt samen met
   pg-reveal.css. De <html>.pg-js class + fallback-timer worden al
   inline in de <head> gezet (snippets/pingion-head.liquid).
   ============================================================ */
(function () {
  'use strict';

  // Veiligheidsklep uit de head uitschakelen: JS is geladen.
  if (window.__pgRV) { clearTimeout(window.__pgRV); window.__pgRV = null; }

  var root = document.documentElement;

  // Respecteer "minder beweging": niets verbergen/animeren.
  var reduce = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) { root.classList.remove('pg-js'); return; }

  // Containers waarvan de directe kinderen na elkaar (gestaggerd) binnenkomen.
  var STAGGER_GROUPS = [
    '.pg-hero__text',
    '.pg-paths__grid',
    '.pg-featured__grid',
    '.pg-b2b-teaser__logos',
    '.pg-blog-teaser__grid',
    '.pg-videos__grid',
    '.pg-story__inner',
    '.pg-faq__list',
    '.pg-reels-strip'
  ];

  // Alle elementen die onthuld moeten worden.
  var TARGETS = [
    '.pg-hero__text > *',
    '.pg-hero__visual',
    '.pg-section-head',
    '.pg-paths__grid > *',
    '.pg-featured__grid > *',
    '.pg-b2b-teaser__intro',
    '.pg-b2b-teaser__logos > *',
    '.pg-b2b-teaser__case',
    '.pg-blog-teaser__grid > *',
    '.pg-videos__grid > *',
    '.pg-story__inner > *',
    '.pg-faq__list > *',
    '.pg-reels-strip > *',
    '.pg-newsletter__inner'
  ].join(',');

  function init() {
    // Stagger-index per groep zetten.
    STAGGER_GROUPS.forEach(function (sel) {
      var container = document.querySelector(sel);
      if (!container) return;
      var kids = container.children;
      for (var i = 0; i < kids.length; i++) {
        kids[i].style.setProperty('--pg-rv-i', i);
      }
    });

    var els = Array.prototype.slice.call(document.querySelectorAll(TARGETS));
    if (!els.length) return;

    // Fallback: geen IntersectionObserver -> alles tonen.
    if (!('IntersectionObserver' in window)) {
      root.classList.add('pg-reveal-all');
      return;
    }

    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
